import { useState } from "react";
import { UserCheck, UserX } from "react-feather";
import { Link } from "react-router-dom";
import { PulseLoader } from "react-spinners";
import ActionConfirmation from "../../../Components/ActionConfirmation/ActionConfirmation";
import NoDataFound from "../../../Components/NoDataFound/NoDataFound";
import SchoolViewModal from "./SchoolViewModal";

const Schools = () => {
  const [CurrentTab, setCurrentTab] = useState(1); // CurrentTab == 1 Approved users or schools,  CurrentTab == 2 pending  users or schools,  CurrentTab == 3 rejected users or schools
  const [genderFilter, setGenderFilter] = useState("");
  const [nameFilter, setNameFilter] = useState("");
  const [emailFilter, setEmailFilter] = useState("");
  const {
    AllUsers,
    navigate,
    OpenRejectDialog,
    handleOpenRejectDialog,
    handleRejectCloseDialog,
    IsLoading,
    OpenApproveDialog,
    handleOpenApproveDialog,
    handleApproveCloseDialog,
  } = SchoolViewModal();

  return (
    <div className="page-wrapper admin-approved-users-page">
      <ActionConfirmation
        title={"Reject user"}
        description={"Are you sure you want to Reject  this user?"}
        openDialog={OpenRejectDialog}
        handleCloseDialog={handleRejectCloseDialog}
      />
      <ActionConfirmation
        title={"Approve  user"}
        description={"Are you sure you want to approve this user?"}
        openDialog={OpenApproveDialog}
        handleCloseDialog={handleApproveCloseDialog}
      />
      <div className="content container-fluid">
        {/* Page Header */}
        <div className="page-header">
          <div className="row">
            <div className="col-sm-12">
              <div className="page-sub-header">
                <h3 className="page-title"> Users</h3>
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/user/admin/dashboard">Admin</Link>
                  </li>
                  <li className="breadcrumb-item active"> Users</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        {/* /Page Header */}
        <div className="student-group-form">
          <div className="row">
            <div className="col-lg-3 col-md-6">
              <div className="form-group">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Search by Gender ..."
                  onChange={(e) => {
                    setGenderFilter(e.target.value);
                  }}
                />
              </div>
            </div>
            <div className="col-lg-3 col-md-6">
              <div className="form-group">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Search by Name ..."
                  onChange={(e) => {
                    setNameFilter(e.target.value);
                  }}
                />
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div className="form-group">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Search by Email ..."
                  onChange={(e) => {
                    setEmailFilter(e.target.value);
                  }}
                />
              </div>
            </div>
            <div className="col-lg-2">
              <div className="search-student-btn">
                <button type="btn" className="btn btn-primary">
                  Search
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-sm-12">
            <div className="card card-table comman-shadow">
              <div className="card-body">
                <div className="row align-items-center">
                  <div className="col-md-12">
                    <div className="card bg-white">
                      <div className="card-body">
                        <ul
                          className="nav nav-tabs 
                     approved-users-nav
                    "
                        >
                          <li
                            className="nav-item"
                            onClick={() => {
                              setCurrentTab(1);
                            }}
                          >
                            <a
                              className={`nav-link ${
                                CurrentTab === 1 ? " active" : ""
                              } `}
                            >
                              Approved
                            </a>
                          </li>
                          <li
                            className="nav-item"
                            onClick={() => {
                              setCurrentTab(2);
                            }}
                          >
                            <a
                              className={`nav-link ${
                                CurrentTab === 2 ? " active" : ""
                              } `}
                            >
                              Pending
                            </a>
                          </li>
                          <li
                            className="nav-item"
                            onClick={() => {
                              setCurrentTab(3);
                            }}
                          >
                            <a
                              className={`nav-link  ${
                                CurrentTab === 3 ? " active" : ""
                              } `}
                            >
                              Rejected
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                {IsLoading ? (
                  <PulseLoader
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                    color="#3D5EE1"
                    size={16}
                  />
                ) : (
                  <div className="table-responsive">
                    <table className="table border-0 star-student table-hover table-center mb-0 datatable table-striped">
                      <thead className="student-thread">
                        <tr>
                          <th>ID</th>
                          <th>Name</th>
                          <th>Email</th>
                          <th>Gender</th>

                          <th className="text-end">Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {CurrentTab === 1
                          ? AllUsers?.length > 0 &&
                            AllUsers.filter((user) => user.IsVerified === 1)
                              .filter(
                                (user) =>
                                  genderFilter === "" ||
                                  user.Gender.toLowerCase().includes(
                                    genderFilter.toLowerCase()
                                  )
                              )
                              .filter(
                                (user) =>
                                  nameFilter === "" ||
                                  `${user.FirstName} ${user.LastName}`
                                    .toLowerCase()
                                    .includes(nameFilter.toLowerCase())
                              )
                              .filter(
                                (user) =>
                                  emailFilter === "" ||
                                  user.Email.toLowerCase().includes(
                                    emailFilter.toLowerCase()
                                  )
                              )
                              .map((user, index) => {
                                return (
                                  <tr
                                    className="user-table-row"
                                    onClick={() => {
                                      navigate(
                                        `/user/admin/users/profile/${user?.id}`
                                      );
                                    }}
                                    key={index}
                                  >
                                    <td>{index + 1}</td>
                                    <td>
                                      <h2 className="table-avatar">
                                        <a className="text-capitalize">
                                          {user?.FirstName +
                                            " " +
                                            user?.LastName}
                                        </a>
                                      </h2>
                                    </td>
                                    <td>{user?.Email}</td>
                                    <td className="text-capitalize">
                                      {user?.Gender}
                                    </td>

                                    <td className="text-end">
                                      <div className="actions">
                                        <a
                                          className="btn btn-sm bg-success-light me-2 "
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            handleOpenRejectDialog(user.uid);
                                          }}
                                        >
                                          <UserX size={18} />
                                        </a>
                                      </div>
                                    </td>
                                  </tr>
                                );
                              })
                          : CurrentTab === 2
                          ? AllUsers.length > 0 &&
                            AllUsers?.filter((user) => user.IsVerified === 0)
                              ?.filter(
                                (user) =>
                                  genderFilter === "" ||
                                  user.Gender.toLowerCase().includes(
                                    genderFilter.toLowerCase()
                                  )
                              )
                              .filter(
                                (user) =>
                                  nameFilter === "" ||
                                  `${user.FirstName} ${user.LastName}`
                                    .toLowerCase()
                                    .includes(nameFilter.toLowerCase())
                              )
                              .filter(
                                (user) =>
                                  emailFilter === "" ||
                                  user.Email.toLowerCase().includes(
                                    emailFilter.toLowerCase()
                                  )
                              )
                              .map((user, index) => {
                                return (
                                  <tr
                                    className="user-table-row"
                                    onClick={() => {
                                      navigate(
                                        `/user/admin/users/profile/${user?.id}`
                                      );
                                    }}
                                    key={index}
                                  >
                                    <td>{++index}</td>
                                    <td>
                                      <h2 className="table-avatar">
                                        <a className="text-capitalize">
                                          {user?.FirstName +
                                            " " +
                                            user?.LastName}
                                        </a>
                                      </h2>
                                    </td>
                                    <td> {user?.Email}</td>
                                    <td className="text-capitalize">
                                      {" "}
                                      {user?.Gender}
                                    </td>

                                    <td className="text-end">
                                      <div className="actions ">
                                        <a
                                          className="btn btn-sm bg-success-light me-2"
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            handleOpenRejectDialog(user.uid);
                                          }}
                                        >
                                          <UserX size={18} />
                                        </a>

                                        <a
                                          className="btn btn-sm bg-success-light me-2"
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            handleOpenApproveDialog(user.uid);
                                          }}
                                        >
                                          <UserCheck size={18} />
                                        </a>
                                      </div>
                                    </td>
                                  </tr>
                                );
                              })
                          : CurrentTab === 3
                          ? AllUsers.length > 0 &&
                            AllUsers?.filter((user) => user.IsVerified === 2)
                              ?.filter(
                                (user) =>
                                  genderFilter === "" ||
                                  user.Gender.toLowerCase().includes(
                                    genderFilter.toLowerCase()
                                  )
                              )
                              .filter(
                                (user) =>
                                  nameFilter === "" ||
                                  `${user.FirstName} ${user.LastName}`
                                    .toLowerCase()
                                    .includes(nameFilter.toLowerCase())
                              )
                              .filter(
                                (user) =>
                                  emailFilter === "" ||
                                  user.Email.toLowerCase().includes(
                                    emailFilter.toLowerCase()
                                  )
                              )
                              .map((user, index) => {
                                return (
                                  <tr
                                    className="user-table-row"
                                    onClick={() => {
                                      navigate(
                                        `/user/admin/users/profile/${user?.id}`
                                      );
                                    }}
                                    key={index}
                                  >
                                    <td>{index + 1}</td>
                                    <td>
                                      <h2 className="table-avatar">
                                        <a className="text-capitalize">
                                          {user?.FirstName +
                                            " " +
                                            user?.LastName}
                                        </a>
                                      </h2>
                                    </td>
                                    <td>{user?.Email}</td>
                                    <td className="text-capitalize">
                                      {user?.Gender}
                                    </td>

                                    <td className="text-end">
                                      <div className="actions">
                                        <a
                                          className="btn btn-sm bg-success-light me-2"
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            handleOpenApproveDialog(user.uid);
                                          }}
                                        >
                                          <UserCheck size={18} />
                                        </a>
                                      </div>
                                    </td>
                                  </tr>
                                );
                              })
                          : ""}
                      </tbody>
                    </table>
                    {CurrentTab === 1 &&
                      AllUsers.filter((user) => user.IsVerified === 1)
                        ?.length <= 0 && <NoDataFound />}
                    {CurrentTab === 2 &&
                      AllUsers.filter((user) => user.IsVerified === 0)
                        ?.length <= 0 && <NoDataFound />}
                    {CurrentTab === 3 &&
                      AllUsers.filter((user) => user.IsVerified === 2)
                        ?.length <= 0 && <NoDataFound />}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Schools;
